"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.overlayVisibleOpacity = exports.overlayHiddenOpacity = exports.animateOutOpacityConfig = exports.animateInOpacityConfig = void 0;
const overlayHiddenOpacity = 0;
exports.overlayHiddenOpacity = overlayHiddenOpacity;
const overlayVisibleOpacity = 1;
exports.overlayVisibleOpacity = overlayVisibleOpacity;
const animateInOpacityConfig = {
  property: 'opacity',
  easing: 'enterFunctional',
  duration: 'moderate1',
  toValue: overlayVisibleOpacity,
  fromValue: overlayHiddenOpacity
};
exports.animateInOpacityConfig = animateInOpacityConfig;
const animateOutOpacityConfig = {
  property: 'opacity',
  easing: 'global',
  duration: 'fast1',
  toValue: overlayHiddenOpacity,
  fromValue: overlayVisibleOpacity
};
exports.animateOutOpacityConfig = animateOutOpacityConfig;